import React from 'react';
import { SimplifyCityType } from '@/types/city';
import CityCard from '@/components/seo/city/CityCard';

const HotCities = ({ hotCities }: { hotCities: SimplifyCityType[] }) => {
  if (!Array.isArray(hotCities) || !hotCities.length) {
    return null;
  }

  return (
    <div className="my-16">
      <h3 className="text-2xl font-semibold mb-10">热门城市薪酬</h3>
      <ul className="!m-0 grid grid-cols-4 gap-x-4 gap-y-5">
        {hotCities.map((data, index) => (
          <CityCard key={data.id + index} {...data} />
        ))}
      </ul>
    </div>
  );
};

export default HotCities;
